import React, { useEffect, useState } from "react"

import {
    Row,
    Col,
    Card,
    CardBody,
    FormGroup,
    Label,
    Input,
    Container,
    FormFeedback,
    Form,
} from "reactstrap"
// Formik validation
import { useFormik } from "formik"

//Import Breadcrumb
import Breadcrumbs from "../../../../components/Common/Breadcrumb"
import { useHistory, useParams } from "react-router-dom"
import ResultHandler from "../../../../components/ResultHandler"
import { editContact, getContact } from "../../../../api/contact"
import FormButtonHandler from "../../../../components/FormButtonHandler"
import useCustomValidation from "../../validationSchema"
import { useResponse } from "../../../../hooks/useResponse"
import { useTranslation } from "react-i18next"
import { useGetInstence } from "../../../../hooks/useGetInstence"
import ContactForm from "./ContactForm"
import FIELDS from "./CONSTANT"
import * as Yup from "yup"

const TYPES = {
    'select': null,
    'add-more': [],
    'checkbox': false,
    'file' : null
}

const initialValues = {}
const FIELDS_VALIDATION = {}

FIELDS.forEach(f => {
    initialValues[f.key] = TYPES[f.type] ? TYPES[f.type] : "" 
    if(f.type == 'file'){
        FIELDS_VALIDATION[f.key+"_preview"] = Yup.string().required("This Field Is Required")

    }else{
        FIELDS_VALIDATION[f.key] = Yup.string().required("This Field Is Required")
    }
})

const EditContact = () => {
    let navigate = useHistory()
    const { contactSchema } = useCustomValidation()

    const { t } = useTranslation()

    const params = useParams()
    const [editedContact, setEditedContact] = useState(null)

    const { instenceLoading, instenceError, instenceSuccess } = useGetInstence(
        getContact,
        params.contactId,
        response => {
            setEditedContact({
                ...response.data.data.companyContact,
            })
        }
    )

    const { setData, loading, error, success } = useResponse(editContact, () => {
        navigate.goBack()
    })

    // Form validation
    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,
        initialValues: {
            ...editedContact,
            _function: editedContact?.function || ""
        },
        validationSchema: Yup.object(FIELDS_VALIDATION),
        onSubmit: data => {
           
            setData({ type: "edit", id: params.contactId, data })
        },
    })



    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid={true}>
                    <Breadcrumbs
                        title={t("Contacts")}
                        breadcrumbItem={t("btns.Edit") + " " + t("Contact")}
                    />
                    
                        {editedContact && (
                            <Form
                                className="needs-validation"
                                onSubmit={e => {
                                    e.preventDefault()
                                    validation.handleSubmit()
                                    return false
                                }}
                            >
                                <ContactForm validation={validation} />

                                <FormButtonHandler btnTxt="Edit" loading={loading} />
                            </Form>


                        )}

                        <ResultHandler
                            loading={instenceLoading}
                            error={error}
                            success={success}
                            successMsg={"Updated Successfully!"}
                        />
                                
                </Container>
            </div>
        </React.Fragment>
    )
}

export default EditContact